import { useSchedulerStore } from "../state/scheduler.store";
import { cancelAutobookHelper } from "../helpers/meeting/cancel";
import { initializeSchedulerStore } from "../helpers/init";
import { useTranslation } from "react-i18next";
import { ReasonType } from "@rooster/types";

export const useCancellation = () => {
  const { t } = useTranslation();
  const { meetingLink, actions } = useSchedulerStore();

  const handleCancel = async (
    availabilityId: string,
    reason?: ReasonType,
    comment?: string
  ) => {
    if (availabilityId) {
      await cancelAutobookHelper({
        availabilityId,
        actions,
        type: meetingLink?.type === "rooster" ? "autobook" : "pml",
        reason,
        comment
      });
      await initializeSchedulerStore(actions, t);
    }
  };

  return { handleCancel };
};
